module.exports = __webpack_public_path__ + "img/0.87b6d30f.jpg";